import { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import { activeReadersLabel, BLOG_VOTE_EVENT } from '@jeraisonne/db';
import { fetchBlogActiveReadersCount } from '@/lib/blog/blog-client';

interface BlogActiveReadersProps {
  articleId: string;
  className?: string;
}

/**
 * Badge « N raisonneurs » — porté depuis
 * apps/marketing/src/components/blog-active-readers.tsx. Pas de pré-seed SSR
 * possible en SPA Vite : démarre à 0 (masqué) puis se peuple au montage.
 * Recompte après chaque vote (`BLOG_VOTE_EVENT`) ou retour sur l'onglet.
 */
export function BlogActiveReaders({ articleId, className }: BlogActiveReadersProps) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const refresh = () => {
      void fetchBlogActiveReadersCount(articleId).then((n) => {
        if (!cancelled && n !== null) setCount(n);
      });
    };
    refresh();
    window.addEventListener(BLOG_VOTE_EVENT, refresh);
    window.addEventListener('focus', refresh);
    return () => {
      cancelled = true;
      window.removeEventListener(BLOG_VOTE_EVENT, refresh);
      window.removeEventListener('focus', refresh);
    };
  }, [articleId]);

  const label = activeReadersLabel(count);
  if (!label) return null;

  return (
    <span className={className}>
      <Users className="size-3.5" aria-hidden />
      {label}
    </span>
  );
}
